export const Skillsdata=[
    {
        type:"FrontEnd",
        list:[
            {
                name:"HTML",
                icon:<i class="devicon-html5-plain-wordmark colored"></i>
            },{
                name:"CSS",
                icon:<i class="devicon-css3-plain-wordmark colored"></i>
            },
            {
                name:"ReactJs",
                icon:<i class="devicon-react-original-wordmark colored"></i>,

            },
            {
                name:"Javascript",
                icon:<i class="devicon-javascript-plain colored"></i>
            },
            
        ]
    },
    {
        type:"BackEnd",
        list:[
            {
                name:"NodeJs",
                icon:<i class="devicon-nodejs-plain-wordmark colored"></i>
            },
            {
                name:"MongoDB",
                icon:<i class="devicon-mongodb-plain-wordmark colored"></i>
            },
           {
               name:"ExpressJs",
               icon:<i class="devicon-express-original-wordmark colored"></i>
           },{
               name:"npm",
               icon:<i class="devicon-npm-original-wordmark colored"></i>
           }

        ]
    }
]